import React from "react";
import type { RfxListTab } from "../../types/rfx-list.type";
import { getApprovalsEmptyStateCopy } from "./approvalsTabAssertion";

export const ApprovalsEmptyState = ({ tab }: { tab: RfxListTab }) => (
	<p className="text-sm pt-4 text-gray-500" data-testid="approvals-empty-copy">
		{getApprovalsEmptyStateCopy(tab)}
	</p>
);
